import { FC } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DetailsRow } from 'lib/ClientDataDetails/DetailsRow';
import TemplateDetails from '../TemplateDetails';
import { generalEnum } from 'screens/Clients/utils/generalEnum';
import { ClientDetailsCollection } from 'types/ClientDetails/ClientDetailsCollection';

type CollectionDetailsProps = {
  collectionAgreement: ClientDetailsCollection;
  sumOfLoanPartsInstallment: number;
};

const CollectionDetails: FC<CollectionDetailsProps> = ({
  collectionAgreement,
  sumOfLoanPartsInstallment,
}) => {
  const { t } = useTranslation();
  const translationsRoot = 'clients.clientData.collectionDetails';

  if (!collectionAgreement) {
    return null;
  }

  return (
    <Grid container data-testid="collectionDetails-container">
      <Grid md={6} item px={3} py={2} mr={1}>
        <TemplateDetails title={t(`${translationsRoot}.generalTitle`)}>
          <DetailsRow
            type="date"
            label={t(`${translationsRoot}.startDate`)}
            value={collectionAgreement.startDate}
          />
          <DetailsRow
            type="currency"
            label={t(`${translationsRoot}.collectionAmount`)}
            value={sumOfLoanPartsInstallment}
          />
        </TemplateDetails>
      </Grid>
      {collectionAgreement.accounts.map((collectionAgreement, index) => {
        return (
          <Grid xs={12} md={6} item px={3} py={2} key={`${collectionAgreement.iban}-${index}`}>
            <TemplateDetails title={t(`${translationsRoot}.collectionAgreementTitle`)}>
              <DetailsRow
                type="string"
                label={t(`${translationsRoot}.iban`)}
                value={collectionAgreement.iban}
              />
              <DetailsRow
                type="string"
                label={t(`${translationsRoot}.paymentMethod`)}
                value={generalEnum('paymentMethod', collectionAgreement.paymentMethod)}
              />
              <DetailsRow
                type="string"
                label={t(`${translationsRoot}.percentage`)}
                value={`${collectionAgreement.percentage}%`}
              />
            </TemplateDetails>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CollectionDetails;
